import { nanoid } from "nanoid";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function createTimerRoom(adminUid, timerState) {
  const roomId = nanoid(6);
  const roomRef = doc(db, "timers", roomId);

  await setDoc(roomRef, {
    id: roomId,
    adminUid,
    ...timerState,
    lastUpdated: Date.now(),
    createdAt: new Date(),
  });

  return roomId;
}
